module.exports = __webpack_public_path__ + "ug.svg?69ed4876cb991fc0c03f2ad3ca250a86";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ug.svg
// module id = 1671
// module chunks = 0